/**
 * When updating this file also update `server\src\constants\env\runtimeHostEnv.js`.
 */
export const PRODUCTION = 'production';
export const DEVELOPMENT = 'development';
export const LOCALHOST = 'localhost';
export const STAGE = 'stage';
